import SpriteSymbol from "../../../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../config/webpack/loaders/svg-sprite/utils/sprite";
var symbol = new SpriteSymbol({
  "id": "icon__check",
  "use": "icon__check-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon__check\"><circle cx=\"8\" cy=\"8\" r=\"7.35\" stroke=\"#00cc6a\" stroke-width=\"1.3\" /><path d=\"M5 7.74L7.2 10 11 6\" stroke=\"#00cc6a\" stroke-width=\"1.3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol